
<template>
    <div>
      <div class="fix">
        <div>
          <!-- <el-popover
            placement="left"
            trigger="hover"
            popper-class="thisPopover"> -->
            <div class="fix-one" slot="reference">
              <el-backtop :bottom="402" :right="27" class="set-backtop">
                <img :src="imgUrl.backtop" class="img-normal" />
                <img :src="imgUrl.backtopBlue" class="img-blue" />
                <div class="fix-one-word">返回</div>
              </el-backtop>
            </div>
          <!-- </el-popover> -->
          <div class="line"></div>
          <el-popover
            placement="left"
            trigger="hover"
            popper-class="thisPopover">
            <div>
              <div>电话咨询</div>
              <div>15255615034</div>
              <img src="../assets/icon/triangle.png" class="triangle1" />
            </div>
            <div class="fix-one" slot="reference">
              <img :src="imgUrl.phone" class="img-normal" />
              <img :src="imgUrl.phoneBlue" class="img-blue" />
              <div class="fix-one-word">热线</div>
            </div>
          </el-popover>
          <div class="line"></div>
          <el-popover
            placement="left"
            trigger="hover"
            popper-class="thisPopover">
            <div>
              <div>加微信</div>
              <img :src="imgUrl.code01" class="code-img" />
              <div>关注微信公众号</div>
              <img :src="imgUrl.code03" class="code-img" />
              <img src="../assets/icon/triangle.png" class="triangle2" />
            </div>
            <div class="fix-one" slot="reference">
              <img :src="imgUrl.code"  class="img-normal" />
              <img :src="imgUrl.codeBlue" class="img-blue" />
              <div class="fix-one-word">关注</div>
            </div>
          </el-popover>
          <div class="line"></div>
          <div
            placement="left"
            trigger="hover"
            popper-class="thisPopover">
            <div class="fix-one" slot="reference">
              <a href="https://shop503054747.taobao.com/?spm=pc_detail.30350276.shop_block.dshopinfo.4ccb1479InwI6i" target="_blank">
                <img :src="imgUrl.taobao"  class="img-normal" />
                <img :src="imgUrl.taobaoBlue" class="img-blue" />
                <div class="fix-one-word">
                  淘宝
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import imgUrl from "@/utils/imgUrl"

  export default {
    name: 'Detail',
    data() {
      return {
          isMobile: window.innerWidth < 780,
          imgUrl
      }
    },
    props: {
      msg: String
    }
  }
  </script>
  
  
  <style lang="less">
    .fix{
      border-radius: 30px;
      box-shadow: 2px 6px 10px #00000026;
      padding: 10px 2px;
      background: #fff;
      .fix-one{
        padding: 10px 8px;
        margin-top: -2px;
        position: relative;
        /deep/ .el-backtop{
          display: block;
        }
        .set-backtop{
          position: unset;
          background-color: unset;
          width: unset; 
          height: unset; 
          box-shadow: unset;
          display: unset;
        }
        .fix-one-word{
          color: #989898;
          text-align: center;
          font-size: 14px;
          margin: 6px 0;
          cursor: pointer;
        }
        .img-blue{
          opacity: 0;
          position: absolute;
          top: 10px;
          left: 8px; 
        }
      }
      .fix-one:hover{
        .fix-one-word{
          color: #00D0FF;
        }
        .img-blue{
          opacity: 1;
        }
        .img-normal{
          opacity: 0;
        }
      }
      .line{
        height: 1px;
        background-color: #f5f5f5;
      }
      img{
        display: block;
      }
    }
    .thisPopover{
      min-width: 100px !important;
      text-align: center !important;
      // border: 2px solid #fc0230 !important;
      border-radius: 8px !important;
      position: relative;
      .code-img{
        width: 120px;
        height: 120px;
      }
      .triangle1{
        position: absolute;
        right: -14px;
        top: 25px;
        width: 11%;
      }
      .triangle2{
        position: absolute;
        right: -14px;
        top: 146px;
        width: 11%;
        height: unset;
      }
    }
  </style>
  